import { HubFeature } from '@ats/api/cm';
import { LocDefs, LocMap, MapLocKeys } from '@cm/core/localization';
import { publicDPRoot } from '../../public-meta';

const dpRoot = `${publicDPRoot}|SSO Ingress`;

export type CPSSOIngressErrorLoc =
	| 'CPSSOIngressErrorMessage'
	| 'CPSSOIngressErrorTryAgain'
	| 'CPSSOIngressErrorPageTitle';

export const cpSSOIngressErrorLocs: LocDefs<CPSSOIngressErrorLoc> = {
	CPSSOIngressErrorMessage: {
		defaultValue: 'There was a problem logging in.',
		description: 'Error message displayed when there is an SSO ingress problem logging in.',
		displayPath: `${dpRoot}|Error Message`,
		displayType: 'Content',
		feature: HubFeature.CandidateAccessIntegrationIngress,
		portal: 'CP',
		htmlAllowed: true,
	},
	CPSSOIngressErrorTryAgain: {
		defaultValue: 'Try Again',
		description: 'Try again button for the SSO ingress error page.',
		displayPath: `${dpRoot}|Try Again`,
		displayType: 'Button',
		feature: HubFeature.CandidateAccessIntegrationIngress,
		portal: 'CP',
	},
	CPSSOIngressErrorPageTitle: {
		defaultValue: 'SSO Error',
		description: 'Page title for SSO ingress error page.',
		displayPath: `${dpRoot}|Page Title`,
		displayType: 'Title',
		feature: HubFeature.CandidateAccessIntegrationIngress,
		portal: 'CP',
	}
};

export const LOC_KEYS = MapLocKeys<CPSSOIngressErrorLoc>(cpSSOIngressErrorLocs);

export type CPSSOIngressErrorLocType = LocMap<CPSSOIngressErrorLoc>;
